import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 4rem;
  align-items: center;

  h2{
    display: inline-block;
    margin-bottom: 2rem;
    font-size: 3rem;
    margin-top: 0rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .intro {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
    font-weight: 500;
    color: #e0e0e0;
    line-height: 1.7;
    margin-bottom: 2.5rem;
  }

  .highlights {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .highlight-card {
    display: flex;
    align-items: flex-start;
    gap: 1.5rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 50%, rgba(240, 147, 251, 0.05) 100%);
    border: 1px solid rgba(102, 126, 234, 0.2);
    border-radius: 16px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(10px);
      border-color: rgba(102, 126, 234, 0.5);
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 50%, rgba(240, 147, 251, 0.1) 100%);
      box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
    }

    .icon {
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 12px;
      
      svg {
        width: 26px;
        height: 26px;
        color: white;
      }

      &.gold {
        background: linear-gradient(135deg, #f5af19 0%, #f12711 100%);
      }
    }

    .content {
      h3 {
        font-size: 1.6rem;
        font-weight: 600;
        color: #fff;
        margin-bottom: 0.5rem;
        background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      p {
        font-size: 1.4rem;
        color: #b0b0b0;
        line-height: 1.5;
        margin: 0;
      }
    }
  }

  .about-image{
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
   img{
     width: 350px;
     height: 350px;
     border-radius: 50%;
     object-fit: cover;
     border: 4px solid transparent;
     background: linear-gradient(#1a1a2e, #1a1a2e) padding-box,
                 linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%) border-box;
     box-shadow: 0 10px 40px rgba(102, 126, 234, 0.3);
     transition: all 0.4s ease;
     &:hover{
       transform: scale(1.05);
       box-shadow: 0 15px 50px rgba(102, 126, 234, 0.5);
     }
   }
  }

  @media only screen and (max-width: 480px) {
    .about-image {
      max-width: 100%;
      margin-top: 4rem;
      img{
        width: 200px;
        height: 200px;
      }
    }

    .highlight-card {
      padding: 1.2rem;
      
      .icon {
        width: 40px;
        height: 40px;
        
        svg {
          width: 20px;
          height: 20px;
        }
      }

      .content {
        h3 {
          font-size: 1.4rem;
        }
        p {
          font-size: 1.2rem;
        }
      }
    }
  }

  @media (max-width: 960px){
    display: block;
    text-align: center;
    grid-template-columns: 1fr;

    .highlights {
      text-align: left;
    }

    .highlight-card {
      &:hover {
        transform: translateY(-5px);
      }
    }
    
    .about-image{
      display: flex;
      justify-content: center;
      max-width: 100%;
      margin-top: 3rem;
      img{
        width: 250px;
        height: 250px;
      }
    }
  }
`;